import { useState } from "react"
import { SystemSS } from "../../../components/SystemSS"
import { FullScreenModal } from "../../../utility/FullScreenModal"

export const FacilitiesJuiceBar = () => {
     const [showModal, setShowModal] = useState(false)
     const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
     const handleOpenModal = (contentType, category, index, maxIndex) => {
         setModalContent({ contentType, category, index, maxIndex })
         setShowModal(true)
         console.log('clickd')
     }
     const handleCloseModal = () => {
         setModalContent({ contentType: '', category: '', index: 0 })
         setShowModal(false)
     }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='juicebar'
                        src={`${process.env.PUBLIC_URL}/images/system/system-juicebar.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Using the Juice Bar, you can redistribute accumulated experience to different characters. The more you increase the level of the Juice Bar, the <span className='text-pborange'>more experience</span> you will be able to accumulate. 
                    </p>{' '}<br/>
                    <p>
                        By making use of the Juice Bar, you can raise the level of a newly-created ally in an instant or level up a Reincarnated ally from Level 1. It’s an extremely useful tool for powering up your characters!
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'juicebar',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <p>
                        If you increase the ratio of EXP stored at the Juice Bar to over 100%, characters that you
                        deploy in battle will receive <span className='text-pborange'>0 EXP</span>, but the amount of EXP that will go to the Juice Bar will be
                        <span className='text-pborange'> over 100%</span>! Talk about a deal!
                    </p>
                </div>
            </section>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    )
}
